import { useState, Fragment } from "react";
import { Icon, IconButton, styled, useTheme } from "@mui/material";
import { TOP_BAR_HEIGHT } from "../../utils/constants";
import { FC } from "react";

interface SearchContainerProps {
  theme: any;
}

const SearchContainer = styled("div")<SearchContainerProps>(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  zIndex: 9,
  width: "100%",
  display: "flex",
  alignItems: "center",
  height: TOP_BAR_HEIGHT,
  background: theme.palette.primary.main,
  color: theme.palette.text.primary,
  "&::placeholder": {
    color: theme.palette.text.primary
  }
}));

const SearchInput = styled("input")(({ theme }) => ({
  width: "100%",
  border: "none",
  outline: "none",
  fontSize: "1rem",
  paddingLeft: "20px",
  height: "calc(100% - 5px)",
  background: theme.palette.primary.main,
  color: theme.palette.text.primary,
  "&::placeholder": { color: theme.palette.text.primary }
}));

const SearchBox: FC = () => {
  const theme = useTheme();
  const [isSearchBoxOpen, setIsSearchBoxOpen] = useState<boolean>(false);

  const toggleSearchBox = (): void => {
    setIsSearchBoxOpen(!isSearchBoxOpen);
  }

  return (
    <Fragment>
      {!isSearchBoxOpen && (
        <IconButton onClick={toggleSearchBox}>
          <Icon sx={{ color: theme.palette.text.primary }}>search</Icon>
        </IconButton>
      )}
      {isSearchBoxOpen && (
        <SearchContainer theme={theme}>
          <SearchInput type="text" placeholder="Search here..." autoFocus />
          <IconButton onClick={toggleSearchBox} sx={{ mx: 2, verticalAlign: "middle" }}>
            <Icon sx={{ color: theme.palette.text.primary }}>close</Icon>
          </IconButton>
        </SearchContainer>
      )}
    </Fragment>
  );
};

export default SearchBox;